// Valid Contract Employee Job Codes for Front Line users
export const contractEmpJobCodes = [
  '437E',
  '480E',
  'MAH2',
  'MAL2',
  'MAS2',
  'MBC2',
  'MES2',
  'MIN2',
  'MLM2',
  'MLR2',
  'MMS2',
  'MPM2',
  'MRF2',
  'MRM2',
  'MRQ2',
  'MRTQ',
  'MSM2',
  'MSS2',
  'MX15',
  'MX18',
  'MX48',
  'MX55',
  'MX70',
  'MXAH',
  'MXAL',
  'MXAS',
  'MXBC',
  'MXCS',
  'MXES',
  'MXIN',
  'MXLM',
  'MXLR',
  'MXM2',
  'MXMM',
  'MXMS',
  'MXPM',
  'MXRF',
  'MXRM',
  'MXSM',
  'MXSS',
  'STM2',
  'STMS',
  'MX41',
  'MX51',
  'MX53',
  'MX59',
  'MX54',
  'MX50',
  'MX52',
  'MX49',
  'MX56',
  'MX01',
  'MX11',
  'MX13',
  'MX14',
  'MX12',
  'MX10',
  'MX16',
  'MX42',
  'MX02'
];

// Function to check if MFE should load based on role and job code validation.
export const shouldLoadMFE = (mfeConfig, userRole, userJobProfileId) => {
  // Validate inputs
  if (!mfeConfig || !userRole) {
    console.warn('Invalid MFE config or user role provided');
    return false;
  }

  // Check if user has required role
  if (!mfeConfig.roles?.includes(userRole)) {
    return false;
  }

  // Additional job code check for Front Line users
  if (
    userRole === 'TechOps-WorkForceNavigator-Front Line' &&
    mfeConfig.checkCodesForFrontLine === 'true'
  ) {
    if (!userJobProfileId) {
      console.warn('Job profile ID missing for Front Line user');
      return false;
    }
    const shouldLoad = contractEmpJobCodes.includes(userJobProfileId);
    console.log('MFE access decision:', mfeConfig.name, shouldLoad);
    return shouldLoad;
  }

  return true;
};
